import { render, staticRenderFns } from "./InspectionIncomingList.vue?vue&type=template&id=a567160e&scoped=true"
import script from "./InspectionIncomingList.vue?vue&type=script&lang=js"
export * from "./InspectionIncomingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a567160e",
  null
  
)

export default component.exports